module.exports = __webpack_public_path__ + "static/media/SpaceGrotesk-Medium.b23b524c.woff";